'use client';

import { ButtonLink } from '@packages/shared/src/ui/Button/Button';

/**
 * This component shows static content for an error page
 *
 * @param title contains title
 * @param description contains description
 * @param info contains further information
 * @param buttonLabel contains label of back button
 * @returns JSX.Element to be placed in Error Pages
 */
export type StaticErrorContentProps = {
  title: string;
  description?: string;
  info?: string;
  buttonLabel?: string;
};

export const StaticErrorContent = ({
  title,
  description,
  info,
  buttonLabel,
}: StaticErrorContentProps) => (
  <div className="flex flex-col items-center justify-center pt-2">
    <p className="text-size-h2 [&::after]:border-color-primary mb-3 self-center font-semibold [&::after]:mx-auto [&::after]:my-1 [&::after]:block [&::after]:w-6.5 [&::after]:border-b-2 [&::after]:content-['']">
      {title}
    </p>
    {description && (
      <p className={`text-size-body1 self-center ${info ? 'mb-0' : 'mb-4'}`}>{description}</p>
    )}
    {info && <p className="text-size-body1 mb-4 self-center">{info}</p>}
    {buttonLabel && (
      <ButtonLink color="primary" href="/">
        {buttonLabel}
      </ButtonLink>
    )}
  </div>
);
